export default __webpack_public_path__ + "static/typography-ga-improved-legibility-eb69ac1b16dd5b3f2f389a5fe393d1f3.png";